<template lang="pug" src="./custom-technology-invisalign.pug"></template>

<script>
import Title from 'components/block/block-title/block-title'

export default {
  props: ['props'],
  components: {
    Title
  },
  methods: {
    fadeUp () {
      this.$refs.img.classList.add('slide-in')
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-technology-invisalign.vue?fb82c786